import React from 'react';
import { Link } from 'react-router-dom';

const categories = [
  {
    id: 'bimetal',
    icon: 'fa-wave-square',
    title: 'Bimetal Şerit Testereler',
    desc: 'Genel çelik ve profil kesimleri için en ekonomik ve uzun ömürlü çözüm. M42 ve M51 diş yapısıyla titreşimi azaltır, üretim maliyetlerinizi düşürür.',
    tag: '14 Model',
    path: '/urunler/bimetal',
  },
  {
    id: 'karbur',
    icon: 'fa-bolt',
    title: 'Karbür Uçlu Şerit Testereler',
    desc: 'Paslanmaz ve sert alaşımlarda maksimum kesim hızı ve dayanıklılık. Titanyum ve Inconel gibi işlemesi zor malzemeler için özel TCT uçlar.',
    tag: '19 Model',
    path: '/urunler/karbur',
  },
  {
    id: 'elmas-cbn',
    icon: 'fa-gem',
    title: 'Elmas ve CBN Testereler',
    desc: 'Cam, seramik ve 55+ HRC çeliklerde sıfır fire ile çapaksız hassas kesim. Geleneksel bıçakların kesemediği malzemeler için özel kaplama.',
    tag: '11 Model',
    path: '/urunler/elmas-cbn',
  },
  {
    id: 'karbon',
    icon: 'fa-leaf',
    title: 'Karbon Şerit Testereler',
    desc: 'Ahşap, plastik ve hafif metaller için esnek ve kırılmaya karşı dirençli yapı. Düşük devirli atölye kesimlerinde maksimum ekonomi sağlar.',
    tag: 'Starrett Serisi',
    path: '/urunler/karbon',
  },
  {
    id: 'daire-testere',
    icon: 'fa-compact-disc',
    title: 'Daire Testereler',
    desc: 'Boru ve profil kesiminde yüksek hassasiyet ve titreşimsiz yüzey kalitesi. Endüstriyel daire testere tezgâhları için optimum çözüm.',
    tag: 'Bilgi ve Detay',
    path: '/urunler/daire-testere',
  },
];

const ProductsOverview = () => (
  <section id="products-overview" className="products-overview">
    <div className="container">
      <div className="text-center reveal">
        <h4 className="section-subtitle">Ürün Yelpazesi</h4>
        <h2 className="section-title">
          Endüstriyel <span className="highlight">Şerit Testere Çözümleri</span>
        </h2>
        <p className="max-w-700 mx-auto mt-2">
          Her tür çelik, alaşım ve kompozit malzemenin kusursuz ve verimli kesimi için Alman ve Amerikan mühendisliği ile geliştirilmiş premium testere bıçakları.
        </p>
      </div>

      <div className="po-grid reveal delay-1">
        {categories.map((cat) => (
          <div key={cat.id} className="po-card">
            <Link to={cat.path} className="po-card-icon" aria-label={cat.title}>
              <i className={`fa-solid ${cat.icon}`}></i>
            </Link>
            <div className="po-card-body">
              <div className="po-card-top">
                <Link to={cat.path} style={{ color: 'inherit' }}>
                  <h3>{cat.title}</h3>
                </Link>
                <span className="po-tag">{cat.tag}</span>
              </div>
              <p><strong>{cat.desc.split('.')[0]}.</strong>{cat.desc.substring(cat.desc.split('.')[0].length + 1)}</p>
              <div className="po-card-actions" style={{ display: 'flex', gap: '10px', marginTop: '1.5rem' }}>
                <Link to={cat.path} className="btn-primary-sm" style={{ flex: 1, textAlign: 'center' }}>
                  Modelleri İncele <i className="fa-solid fa-arrow-right" style={{ marginLeft: '5px' }}></i>
                </Link>
                <a href={`https://wa.me/905470013478?text=Merhaba, ${cat.title} kategorisi hakkında fiyat ve teknik bilgi almak istiyorum.`} target="_blank" rel="noopener noreferrer" className="btn-outline" style={{ padding: '0.5rem 1rem', fontSize: '0.9rem', borderColor: '#25D366', color: '#25D366', flexShrink: 0 }}>
                  <i className="fa-brands fa-whatsapp"></i> Fiyat Al
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    <div className="text-center mt-4">
      <a href="https://wa.me/905470013478" target="_blank" rel="noopener noreferrer" className="btn-secondary" style={{ backgroundColor: '#1e293b' }}>
        <i className="fa-solid fa-headset" style={{ marginRight: '8px' }}></i> Karar veremiyor musunuz? Uzmanımızla konuşun
      </a>
    </div>
  </section>
);

export default ProductsOverview;
